import cloneDeep from 'lodash/cloneDeep';
import { ETAT_BROUILLON } from '@/configuration/devisConf';
import { CATEGORIE_REGROUPEMENT } from '@/configuration/catalogue/produitConf';
import { AUCUN } from '@/configuration/optionBlocage/optionBlocage';

export default function copyFacture(factureACopier) {
  const facture = cloneDeep(factureACopier);
  delete facture.id;
  delete facture.referenceId;
  facture.echeancierPaiement.forEach((echeancier) => { delete echeancier.id; });
  delete facture.code;
  facture.etat = ETAT_BROUILLON;
  facture.avoirsAffectes = [];
  delete facture.creationTime;
  facture.montantAcomptesAffectes = null;
  facture.intervenants.forEach((intervenant) => { delete intervenant.id; });
  facture.lignesCommande.forEach((ligne) => {
    delete ligne.id;
    if (ligne.typeProduit === CATEGORIE_REGROUPEMENT) {
      ligne.etatDeLaDemande = false;
      ligne.etatProvisoire = AUCUN;
      ligne.etatObtenu = AUCUN;
      ligne.rangOption = null;
    }
    ligne.lignesCommande.forEach((ligneEnfant) => { delete ligneEnfant.id; });
    ligne.lignesRemise.forEach((ligneRemise) => { delete ligneRemise.id; });
  });
  facture.repartitionsTva.forEach((tva) => { delete tva.id; });
  facture.tiersFactorId = null;
  facture.factorTransmis = false;
  facture.factorDateTransmission = null;
  delete facture.tiersFactor;
  return facture;
}
